import(/* webpackMode: "eager" */ "/workspace/app/(front)/cart/CartDetails.tsx")